import { createStyles, Theme } from '@material-ui/core/styles';

export const styles = ({ spacing }: Theme) =>
  createStyles({
    root: {
      padding: 0,
    },
    rootWithBorder: {
      borderBottom: '1px solid #EAECF0', // TODO replace after creating new palette

      '& $title': {
        paddingBottom: spacing(4),
      },
    },
    title: {
      alignItems: 'center',
      display: 'flex',
      flexWrap: 'nowrap',
      gap: spacing(2),
      justifyContent: 'space-between',
      padding: spacing(4, 6, 0),
      width: '100%',
    },
    heading: {
      color: '#101828', // TODO replace after creating new palette
      flex: '1 1 auto',
      fontSize: 18,
      fontWeight: 600,
    },
    headingActions: {
      alignItems: 'center',
      display: 'flex',
      flex: '0 0 auto',
      flexWrap: 'nowrap',
      gap: spacing(2),
    },
    closeButton: {
      padding: spacing(0, 2.5),
    },
    closeButtonIcon: {
      fontSize: '15px !important',
    },
  });
